import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {KfReportingService} from '../../services/kf-reporting.service';
import {Master} from '../../../admin/models/master.interface';
import {Page} from '../../../shared/models/page.interface';
import {IdValue} from '../../../shared/models/id-value.interface';
import {ReportCycleDetail} from '../../../admin/models/report-cycle-detail';
import {ClassifierForm} from '../../../admin/models/classifier-form.interface';
import {ClassifierPageEvent} from '../../../admin/models/classifier-page-event.interface';
import {Router} from '@angular/router';
import {MatDialog} from '@angular/material/dialog';
import {ConfirmDialogComponent} from '../../../shared/components/confirm-dialog/confirm-dialog.component';

@Component({
  selector: 'app-kf-next-report-cycle',
  templateUrl: './kf-next-report-cycle.component.html',
  styleUrls: ['./kf-next-report-cycle.component.scss']
})
export class KfNextReportCycleComponent implements OnInit {

  originWizardStep = this.router.getCurrentNavigation()?.extras?.state?.wizardStep;

  yearForm!: FormGroup;
  reportCycleDraft!: ReportCycleDetail;
  years!: number[];
  currentStep = 1;
  wizardStep = 0;
  unuKeys!: Page<Master>;
  previousUNUKeySets!: IdValue[];
  categories!: Page<Master>;
  previousCategoriesSets!: IdValue[];
  collectionStreams!: Page<Master>;
  previousCollectionStreams!: IdValue[];
  step2Completed = false;


  constructor(private formBuilder: FormBuilder,
              private kfReportService: KfReportingService,
              private router: Router,
              private readonly dialog: MatDialog) {
  }

  ngOnInit(): void {
    if (this.originWizardStep !== undefined) {
      this.currentStep = 2;
      this.wizardStep = this.originWizardStep;
    }
    this.kfReportService.getDraftReportCycle().subscribe(data => {
      if (data.content) {
        this.reportCycleDraft = data.content;
        this.years = Array.from({length: 10}, (_, i) => i + this.reportCycleDraft.year);
        this.yearForm = this.formBuilder.group({
          year: [this.reportCycleDraft.year, Validators.required]
        });
      } else  {
        this.kfReportService.getNexReportYear().subscribe(nextYear => {
          this.reportCycleDraft = {year: nextYear};
          this.years = Array.from({length: 10}, (_, i) => i + nextYear);
          this.yearForm = this.formBuilder.group({
            year: [this.reportCycleDraft.year, Validators.required]
          });
        });
      }
    });
    this.kfReportService.getExistingUNUKeys().subscribe(data => this.previousUNUKeySets = data);
    this.kfReportService.getExistingKfCategories().subscribe(data => this.previousCategoriesSets = data);
    this.kfReportService.getExistingCollectionStreams().subscribe(data => this.previousCollectionStreams = data);
  }

  loadStep(step: number): void {
    this.currentStep = step;
  }

  onYearFormSubmit(): void {
    this.reportCycleDraft.year = this.yearForm.value.year;
    this.kfReportService.saveReportCycle(this.reportCycleDraft).subscribe(() => {
      this.currentStep = 2;
      this.wizardStep = 0;
    });
  }

  loadUNUKeys(event: ClassifierPageEvent): void {
    if (event.schemaId) {
      this.kfReportService.getUnuKeysByPreviousReport(event.pageRequest, event.schemaId)
        .subscribe(data => this.unuKeys = data);
    } else {
        this.kfReportService.getActiveUnuKeys(event.pageRequest).subscribe(data => this.unuKeys = data);
    }
  }

  loadPreviousUNUKeySets(): void {
    this.kfReportService.getExistingUNUKeys().subscribe(data => this.previousUNUKeySets = data);

  }

  saveUNUKeyForm(event: ClassifierForm): void {
    const updatedReportCycle = {...this.reportCycleDraft};
    if (event.option === 1) {
      updatedReportCycle.unuKeySetName = event.name;
      updatedReportCycle.previousUnuKeySetId = undefined;
    } else {
      updatedReportCycle.previousUnuKeySetId = event.previousObject?.id;
    }
    this.kfReportService.saveReportCycle(updatedReportCycle)
      .subscribe(data => this.reportCycleDraft = data.content);
  }


  loadCategories(event: ClassifierPageEvent): void {
    if (event.schemaId) {
      this.kfReportService.getCategoriesByPreviousReport(event.pageRequest, event.schemaId)
        .subscribe(data => this.categories = data);
    } else {
      this.kfReportService.getActiveCategories(event.pageRequest).subscribe(data => this.categories = data);
    }
  }

  loadPreviousCategoriesSets(): void {
    this.kfReportService.getExistingKfCategories().subscribe(data => {
      this.previousCategoriesSets = data;
    });

  }

  saveCategoriesForm(event: ClassifierForm): void {
    const updatedReportCycle = {...this.reportCycleDraft};
    if (event.option === 1) {
      updatedReportCycle.kfCategorySetName = event.name;
      updatedReportCycle.previousKfCategorySetId = undefined;
    } else {
      updatedReportCycle.previousKfCategorySetId = event.previousObject?.id;
    }
    this.kfReportService.saveReportCycle(updatedReportCycle)
      .subscribe(data => this.reportCycleDraft = data.content);
  }

  loadCollectionStreams(event: ClassifierPageEvent): void {
     if (event.schemaId) {
      this.kfReportService.getCollectionStreamsByPreviousReport(event.pageRequest, event.schemaId)
        .subscribe(data => this.collectionStreams = data);
    } else {
       this.kfReportService.getActiveCollectionStreams(event.pageRequest).subscribe(data => this.collectionStreams = data);
     }
  }

  loadPreviousCollectionStreams(): void {
    this.kfReportService.getExistingCollectionStreams().subscribe(data => {
      this.previousCollectionStreams = data;
    });

  }

  saveCollectionStreamsForm(event: ClassifierForm): void {
    const updatedReportCycle = {...this.reportCycleDraft};
    if (event.option === 1) {
      updatedReportCycle.collectionStreamName = event.name;
      updatedReportCycle.previousCollectionStreamId = undefined;
    } else {
      updatedReportCycle.previousCollectionStreamId = event.previousObject?.id;
    }
    this.kfReportService.saveReportCycle(updatedReportCycle)
      .subscribe(data => this.reportCycleDraft = data.content);
  }

  launchReport(): void {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      data: {
        item: 'kf-reporting.launch'
      },
      maxWidth: 600
    });
    dialogRef.componentInstance.confirmEvent.subscribe(() => {
      this.kfReportService.launchReportCycle(this.reportCycleDraft).subscribe(
        () =>
          this.router.navigate(['/kfreporting/kfconfiguration/reportcycles'], {state: {message: 'The report cycle has been successfully launched'}})
      );
      dialogRef.close();
    });
  }

  goToStep(event: number): void {
    switch (event) {
      case 1: {
        this.currentStep = 1;
        this.wizardStep = 0;
        break;
      }
      case 2: {
        this.currentStep = 2;
        this.wizardStep = 0;
        break;
      }
      case 3: {
        this.currentStep = 2;
        this.wizardStep = 1;
        break;
      }
      case 4: {
        this.currentStep = 2;
        this.wizardStep = 2;
        break;
      }
    }
  }

  changeWizardStep(value: number): void {
    this.wizardStep = value;
  }
}
